import { useEffect, useRef } from 'react';

// 1000ms = 1s
const INACTIVITY_TIMEOUT_MILISECONDS = 1000 * 60 * 15;

function useInactivityTimeout({ onIdle }) {
  const timeoutId = useRef(null);

  useEffect(() => {
    let lastMouseMove = 0;

    const resetTimer = () => {
      clearTimeout(timeoutId.current);

      timeoutId.current = setTimeout(onIdle, INACTIVITY_TIMEOUT_MILISECONDS);
    }

    const throttledResetTimer = () => {
      const now = Date.now();

      if (now - lastMouseMove > 5000) {
        lastMouseMove = now;
        resetTimer();
      }
    }

    document.addEventListener('mousemove', throttledResetTimer, { passive: true });
    document.addEventListener('mousedown', resetTimer, { passive: true });
    document.addEventListener('keydown', resetTimer, { passive: true });

    return () => {
      document.removeEventListener('mousemove', throttledResetTimer);
      document.removeEventListener('mousedown', resetTimer);
      document.removeEventListener('keydown', resetTimer);
    }
  }, [onIdle]);
}

export default useInactivityTimeout